module.exports = __webpack_public_path__ + "images/stickers/pete-talk.ca098514ef3b83d1e5a7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-talk.png
// module id = DMo5
// module chunks = 24